import React from 'react'

import { Checkbox, Icon, TriangleDown, TriangleUp } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, func, bool, string } from 'prop-types'

function CGTStandardFilterOption({
  option,
  isSelected,
  isExpanded = false,
  disabled = false,
  onClick,
  onToggleExpanded = null,
  isSubitem = false,
  parentValue = null,
}) {
  const hasSubitems = !isSubitem && option.subitems && option.subitems.length > 0
  const showExpandButton = hasSubitems && isSelected

  const checkboxId = isSubitem
    ? `cgt-filter-${parentValue}-${option.value}`
    : `cgt-filter-${option.value}`

  const className = isSubitem
    ? "standard-filters__option standard-filters__option-subitem"
    : "standard-filters__option"

  const handleClick = () => {
    if (isSubitem) {
      onClick(parentValue, option)
    } else {
      onClick(option)
    }
  }

  return (
    <div className={className}>
      <div className="standard-filters__option-content">
        <Checkbox
          id={checkboxId}
          isChecked={isSelected}
          isDisabled={disabled}
          isControlled
          onChange={handleClick}
          label={option.label}
        />
      </div>

      {showExpandButton && (
        <button
          className="standard-filters__expand-button"
          onClick={(e) => onToggleExpanded(option.value, e)}
        >
          <Icon svgComponent={isExpanded ? TriangleUp : TriangleDown} />
        </button>
      )}
    </div>
  )
}

CGTStandardFilterOption.propTypes = {
  option: object.isRequired,
  isSelected: bool.isRequired,
  isExpanded: bool,
  disabled: bool,
  onClick: func.isRequired,
  onToggleExpanded: func,
  isSubitem: bool,
  parentValue: string,
}

export default CGTStandardFilterOption
